import { Duration } from 'luxon';

export const SCHEDULE_COMPLIANCE_DELAY_RISK_THRESHOLD = Duration.fromObject({
  minutes: 30,
});
